export default __webpack_public_path__ + "static/media/card.628e7e54.svg";